import { render, staticRenderFns } from "./ModalSentInvoice.vue?vue&type=template&id=639c8aa0&"
import script from "./ModalSentInvoice.vue?vue&type=script&lang=js&"
export * from "./ModalSentInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports